const handleCarouselKeyPress = (event) => {
	const prevButton = document.querySelector(".f-button.is-prev");
	const nextButton = document.querySelector(".f-button.is-next");

	if (!prevButton && !nextButton) return;

	const actions = {
		ArrowLeft: () => {
			if (prevButton && !prevButton.disabled) {
				event.preventDefault();
				prevButton.click();
				prevButton.focus();
			}
		},
		ArrowRight: () => {
			if (nextButton && !nextButton.disabled) {
				event.preventDefault();
				nextButton.click();
				nextButton.focus();
			}
		}
	};

	actions[event.key]?.();
};

document.addEventListener("keyup", handleCarouselKeyPress);

// Simple mobile swipe support
let touchStartX = 0;
let touchEndX = 0;

document.addEventListener('touchstart', (event) => {
  touchStartX = event.changedTouches[0].screenX;
});

document.addEventListener('touchend', (event) => {
  touchEndX = event.changedTouches[0].screenX;
  handleSwipe();
});

function handleSwipe() {
  const swipeDistance = touchEndX - touchStartX;

  if (swipeDistance > 50) {
    // Swiped right = Previous
    document.querySelector('.f-button.is-prev')?.click();
  } else if (swipeDistance < -50) {
    // Swiped left = Next
    document.querySelector('.f-button.is-next')?.click();
  }
}
